export default "{\n    \"label\": \"Currency\"\n}\n"